import { AgrLoginTypes, IETFLocales, SignupSigninPolicy } from '@next/core-lib/environment';

import { Environment } from './environment.model';

export const environment: Environment = {
  APPLICATION_NAME: 'CustomerDashboard',
  API_BASE_URL: 'http://localhost:4200',
  CLIENT_ID: 'a84b7314-6174-43cf-9b65-a2ee27e710d4',
  REDIRECT_URL: 'http://localhost:4200',
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.All,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset', // NOSONAR (S2068): Azure B2C policy identifier, not a password.
  AUTHORITY: 'https://agrifirmb2cstaging.b2clogin.com/tfp/agrifirmb2cstaging.onmicrosoft.com/',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  APPLICATION_KEY: 'CustomerDashboard',
  APP_INSIGHTS_KEY: '',
  DEFAULT_LOCALE: IETFLocales.nl,
  LOCALES: [IETFLocales.nl, IETFLocales.en, IETFLocales.pl, IETFLocales.fr, IETFLocales.de],
  PRODUCTION: false,
  DISABLE_SSR: false,
  LEGACY_URL: 'https://myagrifirm-onesap-staging.azurewebsites.net/',
  SHOP_URL: 'https://webshop.staging.mcps.agrifirm.com',
  MESTPLACE_URL: 'https://mestplace.staging.mcps.agrifirm.com',
  GRAIN_REGISTRATION_URL: 'https://grain-registration.staging.mcps.agrifirm.com',
  CUSTOMER_IN_LOCATION_SELECTOR: true,
  ORDER_AGAIN: false,
  MSAL_LOGGING: false,
  NGRX_LOGGING: false,
  ERROR_PAGE_HOME_BUTTON: false,
  ERROR_PAGE_BACK_BUTTON: false,
  DELIVERY_TIME_WINDOW_DISABLED: false,
  IDENTIFICATION_TYPES_NL: ['ZCPNL1', 'ZEPEU1', 'ZMONL1', 'ZRONL1'],
  FAQ_URL: 'https://www.agrifirm.nl/over-ons/veelgestelde-vragen/?t=1984&ti=1984#1984',
  RUSH_RETURN: true,
  SHOW_CART_ICON: false,
  SHOW_DISABLED_LOCATION_BADGE: false,
  USE_SHOP_FOR_CART: true,
  APIM_BASE_URL: 'http://localhost:4200/external',
  SUBSCRIBE_TO_CART_EVENTS: false,
  HELP_NL_URL: 'https://www.agrifirm.nl/over-ons/hulp_bij_webshop_en_mijnagrifirm/',
  IS_MY_PROSPECTS_HIDDEN: true,
  ARE_ORDER_BLOCKED_LOCATIONS_HIDDEN: false,
};
